import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {ToastrService} from "ngx-toastr";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private toastrService: ToastrService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let success: boolean = error.error?.success ?? false;
        let errorMessage: string = 'Aconteceu uma falha';

        if (!success && error.error?.data !== undefined) {
          try {
            errorMessage = error.error.data.join('\n');
          } catch (e) {
            errorMessage = error.error.data;
          }
        }

        switch (error.status) {
          case 0:
            errorMessage = 'Não foi possível conectar ao servidor: ' + errorMessage;
            break;
          case 400:
            errorMessage = 'Solicitação incorreta: ' + errorMessage;
            break;
          case 401:
            errorMessage = 'Não autorizado: ' + errorMessage;
            break;
          case 404:
            errorMessage = 'Não encontrado: ' + errorMessage;
            break;
          case 500:
            errorMessage = 'Erro no servidor: ' + errorMessage;
            break;
          default:
            errorMessage = 'Erro geral: ' + errorMessage;
        }

        this.toastrService.error(errorMessage, 'Erro');

        return throwError(error);
      })
    );
  }
}
